import React from "react";
import { Grid, Typography } from "@mui/material";
import { size, COLORS } from "../utils";
import GmailIcon from "../assets/icons/gmail";
import MobileIcon from "../assets/icons/mobile";
import FacebookIcon from "../assets/icons/facebook";
import InstagramIcon from "../assets/icons/instagram";
import YoutubeIcon from "../assets/icons/youtube";
import TwitterIcon from "../assets/icons/twitter";
import LinkedInIcon from "../assets/icons/linkedin";
import styles from "./Footer.module.css";
import { useNavigate } from "react-router-dom";

function Left() {
  const FOLLOW = [
    {
      icon: InstagramIcon,
      href: "#",
    },
    {
      icon: FacebookIcon,
      href: "#",
    },
    {
      icon: TwitterIcon,
      href: "https://x.com/GenesysAIHub",
    },
    {
      icon: LinkedInIcon,
      href: "https://www.linkedin.com/in/genesysaihub",
    },
    {
      icon: YoutubeIcon,
      href: "https://www.youtube.com/@GenesysAIHub",
    },
  ];
  return (
    <Grid
      item
      container
      flexWrap={"nowrap"}
      direction={"column"}
      rowGap={size({ p: 3, h: true })}
      className={styles.leftSection}
    >
      <Grid
        item
        container
        flexWrap={"nowrap"}
        direction={"column"}
        rowGap={size({ p: 0.8, h: true })}
      >
        <Grid item>
          <Typography
            sx={{
              fontFamily: "Archia",
              fontWeight: 600,
              fontSize: size({ p: 1.2 }),
              color: COLORS.C1,
            }}
            className={styles["footer-left-company-name"]}
          >
            Genesys Academy
          </Typography>
        </Grid>
        <Grid item>
          <Typography
            sx={{
              fontFamily: "Archia",
              fontSize: size({ p: 0.95 }),
              fontWeight: 400,
              color: COLORS.C1 + "A0",
              whiteSpace: "nowrap",
            }}
            className={styles["footer-left-copyrights"]}
          >
            Copyright © {new Date().getFullYear()}. All rights reserved.
          </Typography>
        </Grid>
      </Grid>
      <Grid
        item
        container
        flexWrap={"nowrap"}
        direction={"column"}
        rowGap={size({ p: 1, h: true })}
      >
        <Grid item>
          <Typography
            sx={{
              fontFamily: "Archia",
              fontSize: size({ p: 1 }),
              fontWeight: 600,
              color: COLORS.C1,
            }}
            className={styles["footer-left-follow"]}
          >
            Follow Us
          </Typography>
        </Grid>
        <Grid item container columnGap={size({ p: 0.8 })}>
          {FOLLOW.map(({ icon: Icon, href }, i) => (
            <Grid item key={i}>
              <a
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className={styles["footer-left-icon-link"]}
              >
                <Icon
                  width={size({ p: 2 })}
                  height={size({ p: 2 })}
                  fill={COLORS.C1 + "A0"}
                  className={styles["footer-left-icon"]}
                />
              </a>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
}

function Center() {
  const navigate = useNavigate();
  const DATA = {
    Services: {
      "Certification Courses": "/courses",
      "Academic Projects": "/projects",
      "Research Assistance": "/research_assistance",
      "Article Preparation": "/research_assistance",
      "Thesis Drafting": "/research_assistance",
      "Publication Support": "/research_assistance",
    },
    Explore: {
      "Careers": "/careers",
      "Gallery": "/gallery",
      "Help & Support": "/contact_us",
    },
  };
  return (
    <Grid
      item
      container
      flexWrap={"nowrap"}
      columnGap={size({ p: 5 })}
      className={styles.centerSection}
    >
      {Object.keys(DATA).map((k1) => (
        <Grid
          key={k1}
          item
          container
          flexWrap={"nowrap"}
          direction={"column"}
          rowGap={size({ p: 0.7, h: true })}
        >
          <Grid item>
            <Typography
              sx={{
                fontFamily: "Archia",
                fontSize: size({ p: 1 }),
                fontWeight: 600,
                color: COLORS.C1,
              }}
              className={styles["footer-center-title"]}
            >
              {k1}
            </Typography>
          </Grid>
          <Grid
            item
            container
            direction={"column"}
            rowGap={size({ p: 1, h: true })}
          >
            {Object.keys(DATA[k1]).map((k2) => (
              <Grid item key={k2}>
                <Typography
                  sx={{
                    fontFamily: "Archia",
                    fontSize: size({ p: 0.9 }),
                    fontWeight: 400,
                    cursor: "pointer",
                    color: COLORS.C1 + "A0",
                    whiteSpace: "nowrap",
                  }}
                  onClick={() => navigate(DATA[k1][k2])}
                  className={styles["footer-center-list"]}
                >
                  {k2}
                </Typography>
              </Grid>
            ))}
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
}

function Right() {
  const CONTACT = [
    {
      text: "genesysacademy.cs@gmail.com",
      icon: GmailIcon,
      href: "https://mail.google.com/mail/?view=cm&to=genesysacademy.cs@gmail.com",
    },
    { text: "+91 6374934589", icon: MobileIcon, href: "tel:6374934589" },
    { text: "+91 9677583754", icon: MobileIcon, href: "tel:9677583754" },
    { text: "+91 9655395922", icon: MobileIcon, href: "tel:9655395922" },
  ];
  return (
    <Grid
      item
      container
      rowGap={size({ p: 2, h: true })}
      className={styles.rightSection}
    >
      <Grid
        item
        container
        flexWrap={"nowrap"}
        direction={"column"}
        rowGap={size({ p: 1, h: true })}
      >
        <Grid item>
          <Typography
            sx={{
              fontFamily: "Archia",
              fontSize: size({ p: 1 }),
              fontWeight: 600,
              color: COLORS.C1,
            }}
          >
            Contact
          </Typography>
        </Grid>
        {CONTACT.map((k, idx) => {
          const Icon = k.icon;
          return (
            <Grid
              key={idx}
              item
              container
              flexWrap={"nowrap"}
              alignItems={"center"}
              columnGap={size({ p: 0.5 })}
            >
              <Grid item>
                <Icon
                  width={size({ p: 1.4 })}
                  height={size({ p: 1.4 })}
                  fill={COLORS.C1 + "A0"}
                  className={styles["footer-right-icon"]}
                />
              </Grid>
              <Grid item>
                <Typography
                  sx={{
                    fontFamily: "Archia",
                    fontSize: size({ p: 0.9 }),
                    fontWeight: 400,
                    cursor: "pointer",
                    color: COLORS.C1 + "A0",
                    textDecoration: "none",
                  }}
                  component={k.href ? "a" : "span"}
                  href={k.href || undefined}
                  target={k.href?.startsWith("http") ? "_blank" : undefined}
                  rel={
                    k.href?.startsWith("http")
                      ? "noopener noreferrer"
                      : undefined
                  }
                  className={styles["footer-right-list"]}
                >
                  {k.text}
                </Typography>
              </Grid>
            </Grid>
          );
        })}
      </Grid>
      <Grid
        item
        container
        flexWrap={"nowrap"}
        direction={"column"}
        rowGap={size({ p: 0.8, h: true })}
      >
        <Grid item>
          <Typography
            sx={{
              fontFamily: "Archia",
              fontSize: size({ p: 1 }),
              fontWeight: 600,
              color: COLORS.C1,
            }}
          >
            Address
          </Typography>
        </Grid>
        <Grid item>
          <Typography
            sx={{
              fontFamily: "Archia",
              fontSize: size({ p: 0.9 }),
              fontWeight: 400,
              color: COLORS.C1 + "A0",
            }}
          >
            No.100, New Shopping Complex,
            <br />
            2nd Floor, Genesys Academy,
            <br />
            Jawaharlal Nehru Street,
            <br />
            Puducherry 605001.
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default function Footer() {
  return (
    <Grid
      component={"footer"}
      container
      flexWrap={"nowrap"}
      justifyContent={"center"}
      width={size({ p: 100 })}
      padding={`0px ${size({ p: 10 })}`}
      columnGap={size({ p: 9 })}
      className={styles.footerContainer}
    >
      <Left />
      <Center />
      <Right />
    </Grid>
  );
}
